export * from './CallLogDialpad';
export * from './CallLogDialpad.interface';
